import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import CategorySelectionPage from './pages/CategorySelectionPage';
import Praxismodul1 from './pages/Praxismodul1';
import Praxismodul2 from './pages/Praxismodul2';
import HealthCare from './pages/HealthCare';
import Organization from './pages/Organization';
import DataManger from './pages/DataManager';
import Navbar from './components/Navbar';
import './css/global.css';

function App() {
  // Initialer Login-Zustand basierend auf localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  // Effekt, um den Login-Status im localStorage zu speichern, wenn sich `isLoggedIn` ändert
  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  const handleLogout = () => {
    setIsLoggedIn(false);
    // Entfernt den Login-Status beim Logout
    localStorage.removeItem('isLoggedIn');
  };

  return (
    <Router>
      <div className="App">
        {isLoggedIn && <Navbar onLogout={handleLogout} />}
        <Routes>
          <Route path="/" element={<LoginPage onLogin={() => setIsLoggedIn(true)} />} />
          <Route path="/module" element={isLoggedIn ? <CategorySelectionPage /> : <Navigate to="/" />} />
          <Route path="/module/pm1" element={isLoggedIn ? <Praxismodul1 /> : <Navigate to="/" />} />
          <Route path="/module/pm2" element={isLoggedIn ? <Praxismodul2 /> : <Navigate to="/" />} />
          <Route path="/module/gp" element={isLoggedIn ? <HealthCare /> : <Navigate to="/" />} />
          <Route path="/module/op" element={isLoggedIn ? <Organization /> : <Navigate to="/" />} />
          <Route path="/data" element={isLoggedIn ? <DataManger /> : <Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;